import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import React from "react";

export function ClassesDialog({ close, classes, classeId, escolherClasseId,adicionar }) {
    const Footer = (
        <div className="flex justify-content-between">
            <div className="" >
                {classes.length > 0 && 
                <Button
                    severity="success"
                    label="Adicionar"
                    icon="pi pi-plus"
                    //disabled={classeId === ''}
                    onClick={() => { adicionar() }}
                />}
            </div>
            <div className="" >
                <Button
                    severity="info"
                    label="Confirmar"
                    icon="pi pi-check"
                    disabled={classeId === ''}
                    onClick={() => { close() }}
                />
            </div>
        </div>
    )

    return (
        <Dialog
            visible
            header={`Classes de cobrança`}
            onHide={close}
            style={{
                maxWidth: window.innerWidth > 760 ? '40vw' : '90vw',
                textAlign: 'center',
            }}
            footer={Footer}
        >
            <div className="grid">
                <div className=" w-full md:w-7/12 mt-4 ml-2">
                    {classes.length > 0 ? 
                    <h5>
                        Foram encontradas classes de cobrança vinculadas ao seu usuário,
                        escolha qual classe deseja utilizar para essa importação.
                    </h5> :
                    <h5>
                        Crie uma classe de cobrança para identificar 
                        as cobranças importadas
                    </h5>}
                    {classes.length > 0 ? 
                    <Dropdown
                        value={classeId}
                        options={classes}
                        onChange={(event) => escolherClasseId(event.value)}
                        placeholder="Escolha a classe"
                    />:
                    <Button
                        severity="success"
                        label="Adicionar"
                        icon="pi pi-plus"
                        //disabled={classeId === ''}
                        onClick={() => { adicionar() }}
                    />}
                </div>
                <div className=" w-full md:w-1/4">
                    <i
                        className="pi pi-sliders-v p-mr-3 mt-4"
                        style={{ textAlign: "center", color: "blue", fontSize: '10rem' }}
                    />
                </div>
            </div>
        </Dialog>
    );
}
